export default __webpack_public_path__ + "bedfbe33ce3215553ca0d64d8d2504de.svg";